import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-podio-comissoes',
    templateUrl: './podio-comissoes.component.html',
    styleUrls: ['./podio-comissoes.component.scss']
})

export class PodioComissoesComponent implements OnInit {
    unidadeLogadoId: any = null;

    constructor(
        private dialogRef: MatDialogRef<PodioComissoesComponent>,
        @Inject(MAT_DIALOG_DATA) public data,
    ){

    }
    
    ngOnInit(): void {
        this.unidadeUsuarioLogado();
    }

    close(): void {
        this.dialogRef.close();
    }
    
  unidadeUsuarioLogado(): void {

    const token = JSON.parse(window.localStorage.getItem('accessToken'));
    var usuarioLogadoId = token?.user.id;
    var userName = token?.user.userName;
    //var unidadeLogadoId = 0;
    if (userName != "admin") this.unidadeLogadoId = token?.user.unidade.id;
    
  }
}